import React, { createContext, useContext, useState, useEffect } from 'react';
import { companyId } from '../utils/remindMeServices/RemindMeAPIServices';

interface RemindMeContextType {
    companyId?: string;
    selectedEmail: string;
    updateEmail: (email: string) => void;
}

const RemindMeContext = createContext<RemindMeContextType | undefined>(undefined);

export const RemindMeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [selectedEmail, setSelectedEmail] = useState<string>(localStorage.getItem("defaultEmail") || "");


    const updateEmail = (email: string) => {
        setSelectedEmail(email);
        localStorage.setItem("defaultEmail", email);
    }
    useEffect(() => {
        localStorage.setItem("defaultEmail", selectedEmail);
    }, [selectedEmail]);

    return (
        <RemindMeContext.Provider value={{ selectedEmail, updateEmail }}>
            {children}
        </RemindMeContext.Provider>
    );
};

export const useRemindMeContext = () => {
    const context = useContext(RemindMeContext);
    if (!context) {
        throw new Error('useRemindMeContext must be used within a RemindMeProvider');
    }
    return context;
};

